const EVENT_NAME = 'elakay:pwa-update';
let registration = null;
let state = { supported: false, checking: false, updateAvailable: false, applying: false, error: '' };

const publish = (patch) => {
  state = { ...state, ...patch };
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: state }));
};

export const getPwaUpdateState = () => ({ ...state });

export const subscribeToPwaUpdates = (listener) => {
  const handler = (event) => listener(event.detail);
  window.addEventListener(EVENT_NAME, handler);
  listener(getPwaUpdateState());
  return () => window.removeEventListener(EVENT_NAME, handler);
};

const watchRegistration = (nextRegistration) => {
  registration = nextRegistration;
  publish({ supported: true, updateAvailable: Boolean(registration.waiting), error: '' });
  registration.addEventListener('updatefound', () => {
    const worker = registration.installing;
    if (!worker) return;
    worker.addEventListener('statechange', () => {
      if (worker.state === 'installed' && navigator.serviceWorker.controller) {
        publish({ checking: false, updateAvailable: true });
      }
      if (worker.state === 'redundant') publish({ checking: false, error: 'La mise à jour PWA a échoué.' });
    });
  });
};

export const registerPwaUpdater = async () => {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return null;
  try {
    watchRegistration(await navigator.serviceWorker.register('/service-worker.js', { scope: '/', updateViaCache: 'none' }));
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (sessionStorage.getItem('elakay-pwa-reloading') === '1') return;
      sessionStorage.setItem('elakay-pwa-reloading', '1');
      window.location.reload();
    });
    sessionStorage.removeItem('elakay-pwa-reloading');
    return registration;
  } catch (error) {
    publish({ supported: true, error: error.message || "Le service de mise à jour n'a pas pu démarrer." });
    return null;
  }
};

export const checkForPwaUpdate = async () => {
  if (!registration) {
    publish({ error: 'Le service de mise à jour PWA n’est pas actif sur ce déploiement.' });
    return false;
  }
  publish({ checking: true, error: '' });
  try {
    await registration.update();
    if (registration.installing) {
      await new Promise((resolve) => {
        const worker = registration.installing;
        const timeout = window.setTimeout(resolve, 15000);
        const settled = () => {
          if (['installed', 'activated', 'redundant'].includes(worker.state)) {
            window.clearTimeout(timeout);
            worker.removeEventListener('statechange', settled);
            resolve();
          }
        };
        worker.addEventListener('statechange', settled);
        settled();
      });
    }
    const available = Boolean(registration.waiting);
    publish({ checking: false, updateAvailable: available });
    return available;
  } catch (error) {
    publish({ checking: false, error: error.message || 'Vérification de mise à jour impossible.' });
    return false;
  }
};

export const applyPwaUpdate = async () => {
  if (!registration?.waiting) {
    await checkForPwaUpdate();
  }
  const worker = registration?.waiting;
  if (!worker) return false;
  publish({ applying: true, error: '' });
  worker.postMessage({ type: 'SKIP_WAITING' });
  return true;
};
